module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dawn-tab-nav-wrapper"
  }, [_c('div', {
    staticClass: "dawn-tab-nav"
  }, [_c('ul', {
    class: {
      "even-spaced": _vm.workflow
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      class: {
        "is-active text-color line-color": tab.isActive, "is-completed text-color line-color": tab.isCompleted
      },
      on: {
        "click": function($event) {
          _vm.selectTab(tab)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": tab.href
      }
    }, [(tab.icon) ? _c('span', {
      staticClass: "tab-icon-wrapper"
    }, [_c('i', {
      class: [{
        "complete": tab.isCompleted
      }, tab.iconClass]
    })]) : _vm._e(), _c('span', {
      staticClass: "tab-title-wrapper"
    }, [_vm._v(_vm._s(tab.title))])])])
  }))]), _c('div', {
    staticClass: "dawn-tab-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db26c27a","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edTabNav/index.vue
// module id = +m6F
// module chunks = 13 14